import React, { useEffect, useRef, useState } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import { useTranslation } from 'react-i18next';
import { addressCoordinatesToLngLat } from '../utils/addressCoordinates';

export default function AddressMap({ address }) {
    const { t } = useTranslation();
    const containerRef = useRef(null);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let map;
        setStatus(null);
        try {
            const position = addressCoordinatesToLngLat(address.data);
            if (!position) {
                setStatus({ error: false, key: 'search.map_no_coordinates' });
                return;
            }
            const region = process.env.REACT_APP_AWS_REGION;
            const apiKey = process.env.REACT_APP_AWS_MAP_API_KEY;
            if (!region || !apiKey) {
                setStatus({ error: true, key: 'search.map_not_configured' });
                return;
            }
            map = new maplibregl.Map({
                container: containerRef.current,
                style: `https://maps.geo.${region}.amazonaws.com/v2/styles/Standard/descriptor?key=${apiKey}&color-scheme=Light`,
                center: position,
                zoom: 17
            });
            map.on('error', () => setStatus({ error: true, key: 'search.map_error' }));
            map.addControl(new maplibregl.NavigationControl());
            new maplibregl.Marker({ color: 'blue' })
                .setLngLat(position)
                .setPopup(new maplibregl.Popup().setText(address.value))
                .addTo(map);
        } catch (error) {
            setStatus({ error: true, key: 'search.map_error' });
        }
        return () => {
            if (map) {
                map.remove();
            }
        };
    }, [address]);

    return (
        <section className="mb-3" aria-label={t('search.address_map')}>
            <h6>{address.value}</h6>
            {status && (
                <div role={status.error ? 'alert' : 'status'} className={status.error ? 'alert alert-danger' : 'alert alert-info'}>
                    {t(status.key)}
                </div>
            )}
            <div ref={containerRef} aria-label={t('search.address_map')} style={{ width: '100%', height: status ? 0 : 350 }} />
        </section>
    );
}
